import { FunctionComponent } from 'react';

import { useGetTicketsQuery } from '@/api/v2/tickets';
import { Customer } from '@/models/customer';
import { usePagination } from '@/hooks/usePagination';
import { TicketsOverviewUI } from '@/components/TicketsOverviewUI/TicketsOverviewUI';
import { useGetLiftOperatorsQuery } from '@/api/v2/liftOperator';
import { useTranslation } from 'react-i18next';

type CustomerTicketsTableProps = {
    customer: Customer;
};

export const CustomerTicketsTable: FunctionComponent<
    CustomerTicketsTableProps
> = ({ customer }) => {
    const { i18n } = useTranslation();
    const { data, isLoading } = useGetTicketsQuery({
        userId: customer.id,
        size: 100,
    });
    const { data: liftOperators } = useGetLiftOperatorsQuery();

    const { currentItems, setNextPage, setItemsPerPage } = usePagination({
        items: data?.content || [],
        itemsPerPage: 5,
    });

    return (
        <TicketsOverviewUI
            currentPageTickets={currentItems}
            ticketsTotal={data?.totalElements || 0}
            ticketsPerPage={5}
            onPageSizeChange={(nextValue) => {
                setItemsPerPage(nextValue);
            }}
            onPageChange={(nextValue) => {
                setNextPage(nextValue);
            }}
            hideColumns={['liftOperator']}
            hideDetailFields={['liftOperator']}
            ticketsLoading={isLoading}
            liftOperators={liftOperators}
            locale={i18n.language}
            translations={{
                de: i18n.store.data.de.translations as Record<string, string>,
                en: i18n.store.data.en.translations as Record<string, string>,
            }}
        />
    );
};
